import {storage, COUNTER_TYPES} from '@/utils/storage';
import {queryClient} from '@/lib/queryClient';
import {SELECTABLES_KEYS} from '@/hooks/useSelectables';

export function buildBookingPayloadParts() {
    const passengerTypes = queryClient.getQueryData(SELECTABLES_KEYS.passengerTypes) ?? [];
    const carSeatsTypes = queryClient.getQueryData(SELECTABLES_KEYS.childSeatTypes) ?? [];
    const luggageTypes = queryClient.getQueryData(SELECTABLES_KEYS.luggageTypes) ?? [];

    const passengers = passengerTypes
        .map((type) => ({
            passenger_type_id: type.id,
            quantity: storage.getCounter(COUNTER_TYPES.PASSENGER_TYPE, type.id),
        }))
        .filter((p) => p.quantity > 0);

    const childSeats = carSeatsTypes
        .map((seat) => ({
            child_seat_type_id: seat.id,
            quantity: storage.getCounter(COUNTER_TYPES.CAR_SEAT, seat.id),
        }))
        .filter((s) => s.quantity > 0);

    const luggage = luggageTypes
        .map((type) => ({
            luggage_type_id: type.id,
            quantity: storage.getCounter(COUNTER_TYPES.STANDARD_LUGGAGE, type.id)
                + storage.getCounter(COUNTER_TYPES.OVERSIZED_LUGGAGE, type.id),
        }))
        .filter((l) => l.quantity > 0);

    return {passengers, childSeats, luggage};
}
